import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import IPlanEditor from './IPlanEditor';
import { Table } from 'react-bootstrap';
import PlanEditorListRow from './PlanEditorListRow';

interface IPlanEditorListProps {
    items: IPlanEditor[];
    delete: (id: number) => void;
    triggerEdit: (id: number) => void;
}

const PlanEditorList = (props: IPlanEditorListProps) => {
    return (
        <Table responsive hover>
            <thead>
                <tr>
                    <th>{Translate('plan-editors/list/headers/name')}</th>
                    <th>{Translate('plan-editors/list/headers/role')}</th>
                    <th>{Translate('plan-editors/list/headers/email-address')}</th>
                    <th>{Translate('plan-editors/list/headers/phone-number')}</th>
                    <th>{Translate('plan-editors/list/headers/plan-firm')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.items
                    .sort((a: IPlanEditor, b: IPlanEditor) => {
                        let aPlanFirmName = a.planFirmName.toLowerCase();
                        let aName = a.name.toLowerCase();
                        let bPlanFirmName = b.planFirmName.toLowerCase();
                        let bName = b.name.toLowerCase();

                        if (aPlanFirmName === bPlanFirmName) {
                            if (aName > bName) {
                                return 1;
                            }

                            if (aName < bName) {
                                return -1;
                            }
                        }

                        if (aPlanFirmName > bPlanFirmName) {
                            return 1;
                        }

                        if (aPlanFirmName < bPlanFirmName) {
                            return -1;
                        }

                        return 0;
                    })
                    .map((item: IPlanEditor) => {
                        return (
                            <PlanEditorListRow
                                planEditor={item}
                                key={item.id}
                                delete={props.delete}
                                triggerEdit={props.triggerEdit}
                            />
                        );
                    })}
            </tbody>
        </Table>
    );
};

export default PlanEditorList;
